@if (editable()) {
  <mat-select
    [value]="value()"
    [placeholder]="placeholder()"
    (selectionChange)="onSelect($event.value)"
    (openedChange)="!$event && search.set('')"
    [panelWidth]="null"
    class="status-select"
  >
    <mat-select-trigger>
      <span class="status-trigger" [class]="'state-' + (selected()?.color ?? 'neutral')">
        @if (selected(); as option) {
          @if (option.icon) {
            <mat-icon class="status-trigger-icon">{{ option.icon }}</mat-icon>
          }
          <span class="status-trigger-label">{{ option.label }}</span>
        } @else {
          <span class="status-trigger-placeholder">{{ placeholder() }}</span>
        }
      </span>
    </mat-select-trigger>

    @if (searchable()) {
      <mat-option>
        <ngx-mat-select-search
          [(ngModel)]="search"
          [ngModelOptions]="{ standalone: true }"
          placeholderLabel="Search..."
          noEntriesFoundLabel="No matching options"
        ></ngx-mat-select-search>
      </mat-option>
    }

    @for (option of filteredOptions(); track option.value) {
      <mat-option [value]="option.value" class="status-select-option">
        @if (option.icon) {
          <mat-icon [class]="'status-icon-' + (option.color ?? 'neutral')">{{
            option.icon
          }}</mat-icon>
        }
        <span [class]="'status-label-' + (option.color ?? 'neutral')">{{ option.label }}</span>
      </mat-option>
    }
  </mat-select>
} @else {
  @if (selected(); as option) {
    <span
      class="status-trigger"
      [class]="'state-' + (option.color ?? 'neutral')"
      [matTooltip]="option.label"
    >
      @if (option.icon) {
        <mat-icon class="status-trigger-icon">{{ option.icon }}</mat-icon>
      }
      <span class="status-trigger-label">{{ option.label }}</span>
    </span>
  } @else {
    <span class="status-empty">{{ emptySymbol() }}</span>
  }
}
